import { blueColour, defaultFontNormal } from "../utils/styling";
import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";

export const getFilingDeadlineParagraphs = (data) => {
  const {
    ultimateParentName,
    formattedPoAEnd,
    filingDeadline,
    reportingCompanyName,
  } = data;

  const paragraphs = [
    {
      segments: [
        {
          text: "As set out above, the return has been prepared on the basis that ",
          font: defaultFontNormal,
        },
        {
          text: ultimateParentName,
          font: defaultFontNormal,
        },
        {
          text: " is the ultimate parent of the worldwide CIR group for the period ended ",
          font: defaultFontNormal,
        },
        {
          text: formattedPoAEnd,
          font: defaultFontNormal,
        },
        {
          text: ".",
          defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "The filing deadline for the return is ",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: filingDeadline,
          font: defaultFontNormal,
        },
        {
          text: ". Penalties of £500 are due (if assessed by HMRC within 12 months) for returns that are filed up to three months late, rising to £1,000 for returns submitted more than three months late. A return is of no effect if submitted more than 36 months after the end of the period of account (with the exception of certain revised returns).",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "[In general, the filing deadline will be 12 months after the end of the period of account of the ultimate parent - i.e. the date shown above. However, the deadline may be later if a reporting company has been nominated by HMRC - in which case it is 3 months after the nomination, or following a qualifying takeover (Para 7A, Schedule 7A, TIOPA 2010) - in which case it will be the later of 12 months after the end of the period of account of the ultimate parent or 24 months after the beginning of the period of the period in which the ultimate parent of the CIR group is taken over. There are some other filing deadlines too, for example if a return is required following an enquiry (see, for example, Para 50, Schedule 7A, TIOPA 2010 - if any of these circumstances apply, the deadline above should be amended accordingly]",
          font: defaultFontNormal,
          color: blueColour,
          break: 1,
        },
      ],
    },
    {
      condition: !reportingCompanyName,
      segments: [
        {
          text: "As set out above, the return has been prepared on the basis that there is no nominated reporting company in place for the period. No CIR return has been prepared, on the basis that it is only possible to submit a return where there is a nominated reporting company in place.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Filing Deadline"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
